import { PageStoreDefinition } from "@rmp/core/stores/composables/page/usePageStore";
import { getActivePinia, StoreGeneric, storeToRefs } from "pinia";
import { computed, del, nextTick, onBeforeMount, onBeforeUnmount, onUnmounted, Ref, watch, WatchStopHandle } from "vue";

export interface PageOptions {
	useStore: PageStoreDefinition;
	initializationArguments?: any;
	waitForCondition?: Ref<boolean | undefined>;
	disposeOnUnmount?: boolean;
}

export function usePage(options: PageOptions) {
	const store: StoreGeneric = options.useStore();
	const pinia = getActivePinia();
	const { initialized } = storeToRefs(store);
	let stopWatch: WatchStopHandle | undefined;
	let unmounted = false;

	onBeforeUnmount(() => {
		unmounted = true;
		stopWatch?.();
		store.destroy();
	});

	onUnmounted(() => {
		if(!options.disposeOnUnmount) return;
		store.$dispose();
		if(pinia)
			del(pinia.state.value, store.$id);
	});

	onBeforeMount(async () => {
		await nextTick();
		if(unmounted) return;

		if(options.waitForCondition?.value !== undefined) {
			stopWatch = watch(
				() => options.waitForCondition?.value,
				async (newValue) => {
					if(newValue) {
						await store.initialize(options.initializationArguments);
						stopWatch?.();
					}
				},
				{ immediate: true }
			);
		} else {
			await store.initialize(options.initializationArguments);
		}
	});

	const loading = computed(() => !initialized.value);
	return { loading, initialized };
}
